import { useState } from "react";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { useFavoritos } from "@/hooks/useFavoritos";

interface FavoritosButtonProps {
  propertyId: number;
  propertyTitle: string;
  propertyImage: string;
  propertyPrice?: number; // Opcional - preço agora vem dos períodos de disponibilidade
  propertyLocation: string;
}

const FavoritosButton = ({
  propertyId,
  propertyTitle,
  propertyImage,
  propertyPrice,
  propertyLocation,
}: FavoritosButtonProps) => {
  const { toast } = useToast();
  const { isInFavoritos, addToFavoritos, removeFromFavoritos } = useFavoritos();
  const [isLoading, setIsLoading] = useState(false);

  const isFavorite = isInFavoritos(propertyId);

  const handleToggleFavorito = async () => {
    setIsLoading(true);
    
    try {
      if (isFavorite) {
        const success = await removeFromFavoritos(propertyId);
        if (success) {
          toast({
            title: "Removido dos favoritos",
            description: `${propertyTitle} foi removido dos seus favoritos.`,
          });
        }
      } else {
        const success = await addToFavoritos(propertyId);
        if (success) {
          toast({
            title: "Adicionado aos favoritos",
            description: `${propertyTitle} foi adicionado aos seus favoritos.`,
          });
        }
      }
    } catch (error) {
      toast({
        title: "Erro",
        description: "Não foi possível atualizar os favoritos. Tente novamente.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={handleToggleFavorito}
      disabled={isLoading}
      className="absolute top-4 right-4 bg-background/90 backdrop-blur-sm hover:bg-background/95 transition-colors"
      aria-label={isFavorite ? "Remover dos favoritos" : "Adicionar aos favoritos"}
    >
      <Heart
        className={`h-5 w-5 ${
          isFavorite ? "fill-primary text-primary" : "text-foreground"
        }`}
      />
    </Button>
  );
};

export default FavoritosButton;